import { Box, Grid, Link, Typography } from '@mui/material'

import RectangleButtonComponent from 'components/RectangleButton'

import FilterRow from '../FilterRow'
import { styles } from './FilterRowWithButton.styles'

export const TEST_ID = 'published-ideas-button'

export type Props = {
	buttonOnClick: () => void
	disabled: boolean
}

function CreateButton(props: Props) {
	return (
		<RectangleButtonComponent
			color="secondary"
			variant="outlined"
			text={'CREATE CUSTOM GAME'}
			onClick={props.buttonOnClick}
			disabled={props.disabled}
			sx={styles.CreateButton}
		/>
	)
}

function CreateButtonText(props: { sx?: object }) {
	return (
		<Grid sx={props.sx}>
			<Typography
				data-testid={`create-custom-game-support-text`}
				sx={styles.CustomGamesSupportText}
			>
				Creating custom games is only available for licensed users.
				Request a{' '}
				<Link
					href={'https://go.slalom.com/brainstorm-support'}
					sx={styles.CustomGamesSupportLink}
				>
					license
				</Link>
				.
			</Typography>
		</Grid>
	)
}

export default function FilterRowWithButton(props: Props) {
	return (
		<Grid container item sx={styles.FilterRowGrid}>
			{props.disabled && (
				<Box sx={styles.MobileCreateDisabledBox}>
					<Box
						sx={styles.CreateDisabledButtonBox}
						data-testid="create-custom-game-button-disabled"
					>
						<CreateButtonText sx={styles.CreateButtonTextBox} />
						<CreateButton
							data-testid="create-custom-game-button-disabled"
							buttonOnClick={props.buttonOnClick}
							disabled={props.disabled}
						/>
					</Box>
					<Box sx={styles.MobileCreateButtonDisabledBox}>
						<Box
							sx={styles.MobileCreateButton}
							data-testid="create-custom-game-button-disabled-mobile"
						>
							<CreateButton
								data-testid="create-custom-game-button-disabled-mobile"
								buttonOnClick={props.buttonOnClick}
								disabled={props.disabled}
							/>
						</Box>
						<Box sx={styles.MobileSupportTextDisabled}>
							<CreateButtonText />
						</Box>
					</Box>
				</Box>
			)}
			{!props.disabled && (
				<Box sx={styles.MobileCreateButtonBox}>
					<Box
						sx={styles.MobileCreateButton}
						data-testid="create-custom-game-button"
					>
						<CreateButton
							data-testid="create-custom-game-button"
							buttonOnClick={props.buttonOnClick}
							disabled={props.disabled}
						/>
					</Box>
				</Box>
			)}
			<Box sx={styles.ContentContainer}>
				<FilterRow />
				{!props.disabled && (
					<Box
						sx={styles.CreateButtonBox}
						data-testid="create-custom-game-button-mobile"
					>
						<CreateButton
							data-testid="create-custom-game-button-mobile"
							buttonOnClick={props.buttonOnClick}
							disabled={props.disabled}
						/>
					</Box>
				)}
			</Box>
		</Grid>
	)
}
